module.exports = __webpack_public_path__ + "media/assets/icons/ignite-logo-primary-b4be8d4344ba8ec96a53c11b09915948.png";